const DEVICE_INFO = {
  ip: "192.12.123.12",
  user_agent: window.navigator.userAgent,
  accept_header: "text/html",
  browser_tz: new Date().getTimezoneOffset().toString(),
  browser_color_depth: window.screen.colorDepth.toString(),
  browser_screen_height: window.screen.height.toString(),
  browser_screen_width: window.screen.width.toString(),
  browser_language: window.navigator.language
};

export default DEVICE_INFO;
